<template>
  <b-col>
    <b-row class="custom-row d-flex flex-nowrap">
      <div
        class="header-point d-flex justify-content-center"
        style="width: 40%"
      >
        คำถาม
      </div>
      <div
        class="header-point d-flex justify-content-center"
        style="width: 60%"
      >
        แต้ม
      </div>
    </b-row>

    <b-row
      class="custom-row"
      v-for="(item, index) in dataArr"
      :key="index + 'item'"
      :class="dataForm.isEqual == true && index != 0 ? 'd-none' : ''"
    >
      <div
        class="tag-point"
        style="width: 40%"
        v-if="dataForm.isEqual == false && item.seq != null"
      >
        {{ item.label }}
      </div>
      <div
        class="tag-point d-flex justify-content-center"
        style="width: 60%"
        v-if="dataForm.isEqual == false && item.seq != null"
      >
        {{ item.point ? item.point : 0 }}
      </div>

      <div class="tag-point" style="width: 40%" v-if="dataForm.isEqual == true">
        {{ "All tag" }}
      </div>
      <div
        class="tag-point d-flex justify-content-center"
        style="width: 60%"
        v-if="dataForm.isEqual == true && index == 0"
      >
        {{ item.point ? item.point : 0 }}
      </div>
    </b-row>
  </b-col>
</template>

<script>
export default {
  props: {
    dataArr: { type: Array, default: [] },
    dataForm: { type: Object, default: {} },
  },
  setup(props) {},
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/privilege.css";
</style>